export default __webpack_public_path__ + "static/media/warning--width-restriction--g2.3c708099.png";